// Gardes de navigation : session ouverte, puis espace de travail actif.
import { Squelette } from '@eec/ui';
import type { ReactNode } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { AffichageErreur } from './commun/EtatRequete';
import { useSession } from './session/FournisseurSession';

function Attente() {
  return (
    <div style={{ padding: 32, maxWidth: 640, margin: '0 auto' }}>
      <Squelette lignes={5} libelle="Ouverture de la session" />
    </div>
  );
}

/** Exige une session ; sinon renvoie à la connexion en mémorisant la page demandée. */
export function GardeSession({ children }: { children?: ReactNode }) {
  const { etat } = useSession();
  const location = useLocation();
  if (etat === 'initialisation') return <Attente />;
  if (etat === 'deconnecte') return <Navigate to="/connexion" replace state={{ depuis: `${location.pathname}${location.search}` }} />;
  return children ?? <Outlet />;
}

/** Exige un espace de travail actif et utilisable. */
export function GardeContexte() {
  const { contexte, chargementContexte, erreurContexte, recharger } = useSession();
  if (chargementContexte) return <Attente />;
  if (erreurContexte || !contexte) {
    return (
      <div style={{ padding: 32, maxWidth: 640, margin: '0 auto' }}>
        <AffichageErreur erreur={erreurContexte} onReessayer={() => void recharger()} />
      </div>
    );
  }
  if (contexte.blocage?.code === 'mfa_requis') return <Navigate to="/mfa/activer" replace state={{ appartenanceId: contexte.appartenance_active?.id }} />;
  if (!contexte.appartenance_active || contexte.blocage) return <Navigate to="/contexte" replace />;
  return <Outlet />;
}
